import React, { useEffect, useState } from "react";

import TaxonomyList from "./TaxonomyList";
import ListWrapper from "../../../common/management/ListWrapper";
import ListContentWrapper from "../../../common/management/ListContentWrapper";

import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  getTaxonomiesData,
  requestTaxonomies,
} from "../../../redux/reducers/taxonomy";

import { genDisplayCount } from "../../../utils/GeneralUtils";

type Props = {
  currentPage: number;
  perView: number;
};

const TaxonomyListContainer: React.FC<Props> = ({ currentPage, perView }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const taxonomies = useAppSelector(getTaxonomiesData);

  useEffect(() => {
    setIsLoading(true);

    const promise = dispatch(requestTaxonomies());

    promise.finally(() => setIsLoading(false));

    return () => {
      promise.abort();
    };
  }, []);

  const [totalPages, setTotalPages] = useState<number>(1);

  useEffect(() => {
    if (taxonomies) {
      setTotalPages(Math.ceil(taxonomies.length / perView));
    }
  }, [taxonomies]);

  return (
    <ListWrapper pageTitle={"タクソノミー一覧"}>
      <ListContentWrapper
        isLoading={isLoading}
        currentPage={currentPage}
        displayCount={genDisplayCount(
          currentPage,
          totalPages,
          perView,
          taxonomies.length
        )}
        totalPage={totalPages}
        totalEntries={taxonomies.length}
      >
        <TaxonomyList taxonomies={taxonomies} />
      </ListContentWrapper>
    </ListWrapper>
  );
};

export default TaxonomyListContainer;
